// ============================================================================
// BottomNav — navegação inferior do app do PROFISSIONAL no celular.
// As 4 telas do dia a dia em um toque (antes: hambúrguer + item = 2 toques);
// o resto continua no menu. Só renderiza pra usuário não-admin em <md.
// ============================================================================

import React from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3, Sword, Trophy, Clock, Award, Menu } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.jsx';
import { useData } from '../contexts/DataContext.jsx';
import { isPontoEligible } from '../utils/ponto.js';
import { prefetchRoute } from '../utils/routePrefetch.js';
import { useAvisoAniversario } from '../utils/useAvisoAniversario.js';

export default function BottomNav({ onMenuClick }) {
  const { user } = useAuth();
  const dataCtx = useData();
  // 16/10/2026: ponto vermelho no "Menu" enquanto houver aniversário hoje não visto
  // (hook antes do return: a ordem dos hooks não pode mudar entre renders).
  const avisoAniv = useAvisoAniversario({ professionals: dataCtx?.professionals, userId: user?.id });
  if (!user || user.role === 'admin') return null;

  const myProf = user.professionalId
    ? (dataCtx?.professionals || []).find(p => p.id === user.professionalId)
    : null;
  const showPonto = myProf && isPontoEligible(myProf);

  const items = [
    { to: '/gestao/meu-desempenho', icon: BarChart3, label: 'Desempenho' },
    { to: '/gestao/duelos', icon: Sword, label: 'Duelos' },
    { to: '/gestao/ranking', icon: Trophy, label: 'Ranking' },
    showPonto
      ? { to: '/gestao/bater-ponto', icon: Clock, label: 'Ponto' }
      : { to: '/gestao/minhas-conquistas', icon: Award, label: 'Conquistas' },
  ];

  return (
    <nav
      className="md:hidden flex-shrink-0 bg-ink border-t border-white/10 flex items-stretch pb-[calc(env(safe-area-inset-bottom,0px)+4px)]"
      aria-label="Navegação principal"
    >
      {items.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          onTouchStart={() => prefetchRoute(to)}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] transition-colors duration-180 ease-fk ${
              isActive ? 'text-cream' : 'text-[#8C9CB5]'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={20} strokeWidth={isActive ? 2.2 : 1.75} />
              <span className={`text-[10px] leading-none ${isActive ? 'font-semibold' : 'font-medium'}`}>{label}</span>
            </>
          )}
        </NavLink>
      ))}
      <button
        onClick={onMenuClick}
        className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-[#8C9CB5] active:text-cream transition-colors duration-180 ease-fk"
      >
        <span className="relative inline-flex">
          <Menu size={20} strokeWidth={1.75} />
          {avisoAniv.pendente && (
            <span className="absolute -top-0.5 -right-1 w-2 h-2 rounded-full bg-danger" title="Aniversário hoje">
              <span className="sr-only">Aniversário hoje</span>
            </span>
          )}
        </span>
        <span className="text-[10px] leading-none font-medium">Menu</span>
      </button>
    </nav>
  );
}
